import {
  MicrosoftWordLogoIcon,
  FilePdfIcon,
  VideoIcon,
  SpeakerHighIcon,
  ImageIcon,
  TableIcon,
  PackageIcon,
  EnvelopeIcon
} from "@phosphor-icons/react";

export const fileTypeIcons = {
  'MS Office': MicrosoftWordLogoIcon,
  'PDF': FilePdfIcon,
  'Video': VideoIcon,
  'Audio': SpeakerHighIcon,
  'Image': ImageIcon,
  'Spreadsheet': TableIcon,
  'Email': EnvelopeIcon,
  'Other': PackageIcon,
} as const;

/** Plural chip labels for file-type inclusion scopes in the QuestionBar. */
export const fileTypeScopeChipLabels: Record<keyof typeof fileTypeIcons, string> = {
  'MS Office': 'MS Office files',
  'PDF': 'PDFs',
  'Video': 'Videos',
  'Audio': 'Audio files',
  'Image': 'Images',
  'Spreadsheet': 'Spreadsheets',
  'Email': 'Emails',
  'Other': 'Other files',
};

export function fileTypeScopeChipLabel(fileType: string): string {
  return fileTypeScopeChipLabels[fileType as keyof typeof fileTypeIcons] ?? fileType;
}

/**
 * Preserve exact characters in path/filename UI (including consecutive spaces).
 * Default HTML whitespace collapsing would otherwise turn ``a  b`` into ``a b``,
 * so select/copy from the rendered text would not match the original path.
 *
 * Use with wrapping path text (``break-all`` / ``break-words``). For single-line
 * truncated segments prefer {@link PATH_SEGMENT_TRUNCATE_CLASSNAME} instead.
 */
export const PATH_DISPLAY_WHITESPACE_CLASSNAME = 'whitespace-break-spaces';

/**
 * Single-line truncated path segment: keep consecutive spaces while ellipsizing.
 * Avoid Tailwind ``truncate`` here — it sets ``whitespace-nowrap``, which still
 * collapses runs of spaces.
 */
export const PATH_SEGMENT_TRUNCATE_CLASSNAME =
  'min-w-0 overflow-hidden text-ellipsis whitespace-pre';

/**
 * Truncate long paths while keeping the filename (tail) visible. Pair with an
 * ``&lrm;`` prefix on the text node so RTL ellipsis clips the directory prefix.
 * Alignment (``text-left`` / ``text-right``) is up to the caller.
 */
export const PATH_FILENAME_VISIBLE_TRUNCATE_CLASSNAME =
  'min-w-0 overflow-hidden text-ellipsis whitespace-pre dir-rtl';
